import Container from "@/components/ui/container";
import IconExpandWindow from "@/components/icons/icon-expand-window";

export default function SharesPage() {
	return (
		<div className="space-y-6 py-12">
			<Container>
				<div className="flex flex-col items-center justify-center min-h-[calc(100vh-20rem)] px-4">
					<div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
						<IconExpandWindow className="w-8 h-8 text-gray-400" />
					</div>
					<h3 className="text-lg font-semibold text-gray-900 mb-2">Coming Soon</h3>
					<p className="text-sm text-gray-500 text-center max-w-sm">We're working on building a powerful shares management system. Stay tuned for updates!</p>
				</div>
			</Container>
		</div>
	);
}
